import React from "react";

export default ({ scrollimg }) => {
    return (
        <img id="scroller-img" src={scrollimg} className="scroll-image" alt="Scroll" />
    );
}